
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-ef542d2eab";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
const $b6785f1d81c92020$var$BASE_URL = "https://www.atlassian.com";
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: "ja",
        langRoute: "ja"
    },
    {
        hrefLang: "fr",
        langRoute: "fr"
    },
    {
        hrefLang: "de",
        langRoute: "de"
    },
    {
        hrefLang: "es",
        langRoute: "es"
    },
    {
        hrefLang: "pt-BR",
        langRoute: "br"
    },
    {
        hrefLang: "zh-Hans",
        langRoute: "zh"
    },
    {
        hrefLang: "ko",
        langRoute: "ko"
    },
    {
        hrefLang: "ru",
        langRoute: "ru"
    },
    {
        hrefLang: "pl",
        langRoute: "pl"
    },
    {
        hrefLang: "it",
        langRoute: "it"
    },
    {
        hrefLang: "nl",
        langRoute: "nl"
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== "undefined" && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    const route = path !== "" ? "/" + path : "";
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== "undefined") locationData = {
        countryIsoCode: window.countryCode || "",
        regionIsoCode: window.regionIsoCode || ""
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== "undefined" ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== "undefined" ? window.navigator.userAgent : "";
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(()=>{
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${$b6785f1d81c92020$var$BASE_URL}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${$b6785f1d81c92020$var$BASE_URL}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-ignore
            const root = (0, $konOj.createRoot)(document.getElementById("wac"));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), page, {
            onRecoverableError: (error, errorInfo)=>{
                var _document_getElementById;
                (_document_getElementById = document.getElementById("wac-root")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.setAttribute("hydration-error", "true");
            }
        });
    });
};

});

parcelRegister("7surG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56e2c3c1a9226f96$var$_react = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $56e2c3c1a9226f96$var$_baseNew = $56e2c3c1a9226f96$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $56e2c3c1a9226f96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $56e2c3c1a9226f96$var$PersonIcon = (props)=>/*#__PURE__*/ $56e2c3c1a9226f96$var$_react.default.createElement($56e2c3c1a9226f96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$56e2c3c1a9226f96$var$PersonIcon.displayName = 'PersonIcon';
var $56e2c3c1a9226f96$var$_default = module.exports.default = $56e2c3c1a9226f96$var$PersonIcon;

});

parcelRegister("l8kCZ", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return (parcelRequire("bTseT")).IntercomProvider; });
parcelRequire("bTseT");
parcelRequire("25OgP");

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $PE2DD = parcelRequire("PE2DD");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== "undefined";
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $PE2DD.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === "complete") // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener("DOMContentLoaded", handleLoad);
                    window.removeEventListener("load", handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener("DOMContentLoaded", handleLoad);
                window.addEventListener("load", handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error("Intercom: DOM ready timeout reached, proceeding anyway");
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            var _window_intercomSettings;
            const intercomSettings = (_window_intercomSettings = window.intercomSettings) !== null && _window_intercomSettings !== void 0 ? _window_intercomSettings : {
                app_id: appId
            };
            try {
                var _window_Intercom, _window, _window_Intercom1, _window1;
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "boot", (0, $6Ppys._)({
                    alignment: "right",
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: "#intercomLauncher"
                }, intercomSettings));
                (_window_Intercom1 = (_window1 = window).Intercom) === null || _window_Intercom1 === void 0 ? void 0 : _window_Intercom1.call(_window1, "trackEvent", "widget-loaded");
            } catch (error) {
                console.warn("Intercom boot failed:", error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            var _window_Intercom, _window;
            (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "shutdown");
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "show");
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        var _window_Intercom, _window;
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) (_window_Intercom = (_window = window).Intercom) === null || _window_Intercom === void 0 ? void 0 : _window_Intercom.call(_window, "hide");
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get("ajs_anonymous_id") || "";
            if (anonId) intercomSettingsObj["anonymousId"] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj["name"] = getwayApiMeGetResponse.name;
                intercomSettingsObj["email"] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error("This hook must be used within IntercomProvider");
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, "attachEvent");
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            var _x_parentNode;
            const s = d.createElement("script");
            s.type = "text/javascript";
            s.async = true;
            s.src = "https://widget.intercom.io/widget/" + appId;
            const x = d.getElementsByTagName("script")[0];
            x === null || x === void 0 ? void 0 : (_x_parentNode = x.parentNode) === null || _x_parentNode === void 0 ? void 0 : _x_parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent("onload", l);
        else w.addEventListener("load", l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("25OgP", function(module, exports) {
// Intercom Types & Interface ===========================================================
// all the Interface stuff from: https://developers.intercom.com/installing-intercom/web/attributes-objects/

});


parcelRegister("8EEDU", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return (parcelRequire("hBYvx")).Video; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("hBYvx")).Video; });

var $hBYvx = parcelRequire("hBYvx");

});
parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $6Ppys = parcelRequire("6Ppys");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== "none" ? {
        aspectRatio: ratio,
        objectFit: "cover"
    } : {};
    return (0, $6Ppys._)({
        maxWidth: "100%"
    }, aspectRatioCSS);
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        var _videoRef_current;
        (_videoRef_current = videoRef.current) === null || _videoRef_current === void 0 ? void 0 : _videoRef_current.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : "mp4"}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : "mp4"}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});


parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
parcelRequire("j6FQw");
var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: "wac-web",
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    var _props_pageId;
    const pageId = (_props_pageId = props.pageId) !== null && _props_pageId !== void 0 ? _props_pageId : parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("j6FQw", function(module, exports) {
$parcel$export(module.exports, "ScrollTracking", function () { return (parcelRequire("je135")).ScrollTracking; });
$parcel$export(module.exports, "useScrollTracking", function () { return (parcelRequire("je135")).useScrollTracking; });
$parcel$export(module.exports, "withScrollTracking", function () { return (parcelRequire("je135")).withScrollTracking; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return (parcelRequire("5S2vX")).ParentScrollTracking; });
parcelRequire("je135");
parcelRequire("5S2vX");

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)((0, $edEzO._)((0, $6Ppys._)({
        threshold: 0.5,
        triggerOnce: true
    }, observerOptions), {
        skip: (observerOptions === null || observerOptions === void 0 ? void 0 : observerOptions.skip) || !scrollTrackingEnabled
    }));
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: "ui",
                action: "scrolledTo",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6Ppys._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: "ui",
                action: "dwellTimeTracked",
                actionSubject: "section",
                source: window.location.pathname,
                attributes: (0, $6Ppys._)({
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId
                }, additionalAttributes)
            };
            if (analyticsClient) {
                createAnalyticsEvent((0, $6Ppys._)({}, scrollTrackAnalyticsPayload)).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    "mousemove",
                    "keydown",
                    "scroll",
                    "touchstart"
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent((0, $6Ppys._)({}, dwellTimeTrackAnalyticsPayload)).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = "div" })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, (0, $edEzO._)((0, $6Ppys._)({
            section: section
        }, options), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, (0, $6Ppys._)({}, props))
        }));
    };
}

});



parcelRegister("eUwCn", function(module, exports) {
$parcel$export(module.exports, "Adg4Skeleton", function () { return $a7f43d28d2add36d$export$e754784845e8828d; });

var $6Ppys = parcelRequire("6Ppys");

var $6yaZc = parcelRequire("6yaZc");

var $7VQPk = parcelRequire("7VQPk");

var $4jcRW = parcelRequire("4jcRW");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");
const $a7f43d28d2add36d$export$e754784845e8828d = (_param)=>{
    var { width: width, height: height, groupName: groupName, testId: testId } = _param, props = (0, $6yaZc._)(_param, [
        "width",
        "height",
        "groupName",
        "testId"
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), (0, $6Ppys._)({
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $lP7A9.default)("space.100"),
        color: (0, $kbpa7.wacToken)("color.neutral.light200"),
        ShimmeringEndColor: (0, $kbpa7.wacToken)("color.neutral.light300")
    }, props));
};

});

parcelRegister("53RJr", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return (parcelRequire("jVACb")).BannerAlert; });
$parcel$export(module.exports, "default", function () { return (parcelRequire("jVACb")).BannerAlert; });

var $jVACb = parcelRequire("jVACb");

});
parcelRegister("jVACb", function(module, exports) {
$parcel$export(module.exports, "BannerAlert", function () { return $8326461e03189c88$export$4eb8f3e4e539379b; });
/* banner-alert.tsx generated by @compiled/babel-plugin v0.28.8 */ /* eslint-disable local/ensure-wac-token-usage */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $2fk4i = parcelRequire("2fk4i");

var $jMhSx = parcelRequire("jMhSx");

var $2gCne = parcelRequire("2gCne");
const $8326461e03189c88$var$containerStyles = null;
const $8326461e03189c88$var$contentStyles = null;
const $8326461e03189c88$var$closeIconStyles = null;
const $8326461e03189c88$export$4eb8f3e4e539379b = ({ identifier: identifier, text: text, linkText: linkText, linkUrl: linkUrl, dataEventProps: dataEventProps, hasProductNavBar: hasProductNavBar })=>{
    const intl = (0, $8e22h.default)();
    const bannerStorageItem = `BannerAlert_dismiss-${identifier}`;
    const translatedLabel = intl.formatMessage({
        id: "banner-alert.close.aria-label",
        defaultMessage: "Close"
    });
    const [isHidden, setIsHidden] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        let dismissValue = null;
        dismissValue = (0, $2gCne.getLocalStorage)(bannerStorageItem);
        if (dismissValue !== "1") setIsHidden(false);
    }, [
        bannerStorageItem
    ]);
    const dynamicStyles = hasProductNavBar ? {
        marginBlockStart: "60px"
    } : {};
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "banner-alert",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            "data-dismissed": isHidden ? "true" : undefined,
            className: (0, $2jatx.default)([
                "_bfhkuzct _kqswh2mm _y4ti1ejb _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1e0c1txw _1pbykb7n _nzmgglyw"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                    "aria-label": translatedLabel,
                    onClick: ()=>{
                        setIsHidden(true);
                        (0, $2gCne.setLocalStorage)(bannerStorageItem, "1");
                    },
                    className: (0, $2jatx.default)([
                        "_r06hglyw _bfhk1j28 _19itidpf _80omtlke _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw _rjxp1ul9 _152tpxbi _1nj119tk"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Cross), {
                        size: "20"
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    style: dynamicStyles,
                    className: (0, $2jatx.default)([
                        "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _bozgxy5q _y4tixncg _1e0c11p5 _syaz1mpp _1a9ox7w3 _oxk4oelr _rfqo1r31 _1bgkglyw _1t0pnqa1 _1d61glyw _14l354rc"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                children: text
                            }),
                            "\xa0",
                            linkText && linkUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                text: linkText,
                                href: linkUrl,
                                type: "inline",
                                dataEventProps: dataEventProps
                            })
                        ]
                    })
                })
            ]
        })
    });
};

});


parcelRegister("4Jdkw", function(module, exports) {
$parcel$export(module.exports, "ADG4CtaWithPolygonBackground", function () { return $07707e85aaf85d14$export$eacf4ba154ffd9bb; });
/* cta-with-polygon-background.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $5qUgh = parcelRequire("5qUgh");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $07707e85aaf85d14$var$ctaStyles = null;
const $07707e85aaf85d14$var$h3Styles = null;
const $07707e85aaf85d14$var$typographyOverrides = null;
const $07707e85aaf85d14$var$polygonStyles = null;
const $07707e85aaf85d14$export$eacf4ba154ffd9bb = ({ header: header, paragraph: paragraph, ctaText: ctaText, ctaUrl: ctaUrl, ctaLabel: ctaLabel, productKey: productKey, backgroundColor: backgroundColor = "#101214", buttonVariant: buttonVariant = "secondary", buttonColor: buttonColor = "white" })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    const noParagraphSpacing = !paragraph ? "var(--ds-space-400, 32px)" : 0;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            ref: scrollRef,
            className: (0, $2jatx.default)([
                "_p12f1git _18s84p42 _y3gn1h6o",
                "_syaz121t _6rth4cqu",
                sectionIsVisible ? "is-visible" : ""
            ]),
            style: {
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                style: {
                    "--background-color": backgroundColor
                },
                className: (0, $2jatx.default)([
                    "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci",
                    "polygon"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1wyb1fu0 _vwz41da2 _1cqs1h67 _1jw853lb _1bys1fu0",
                                    "_syaz121t _6rth4cqu",
                                    "header h3"
                                ]),
                                style: {
                                    marginBottom: noParagraphSpacing,
                                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                                layout: "8",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_syaz121t _6rth4cqu",
                                        ".body-lg"
                                    ]),
                                    style: {
                                        "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                    },
                                    children: paragraph
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5qUgh.Adg4Button), {
                                variant: buttonVariant,
                                color: buttonColor,
                                colorAgainst: backgroundColor == "#101214" ? "black" : "other",
                                href: ctaUrl,
                                dataEventProps: {
                                    "data-product-key": productKey,
                                    "data-event": "clicked",
                                    "data-event-component": "linkButton",
                                    "data-event-container": "ctaSection",
                                    "data-label-english": ctaLabel
                                },
                                className: (0, $2jatx.default)([
                                    "_6rthzwfg"
                                ]),
                                children: ctaText
                            })
                        ]
                    })
                })
            })
        })
    });
};

});

parcelRegister("l4vdU", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $73f92d32d2fa0cb0$export$2e2bcd8739ae039; });
/* sticky-container.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $32ng3 = parcelRequire("32ng3");
const $73f92d32d2fa0cb0$var$StickyContainer = ({ children: children })=>{
    const isMultipleStickyStart = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacLiftedBannerSticky);
    if (!isMultipleStickyStart) return children;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        "data-testid": "banner-nav-combo",
        className: (0, $2jatx.default)([
            "_kqsw1if8 _152tidpf _1pbyqfx8"
        ]),
        children: children
    });
};
const $73f92d32d2fa0cb0$var$sticky = null;
var $73f92d32d2fa0cb0$export$2e2bcd8739ae039 = $73f92d32d2fa0cb0$var$StickyContainer;

});

parcelRegister("7VkQP", function(module, exports) {
$parcel$export(module.exports, "tabbedHeroSectionPagesMessages", function () { return $5ec21e3943929bcb$export$4256e39427240bad; });
$parcel$export(module.exports, "tabbedHeroSectionWhiteboardsMessages", function () { return $5ec21e3943929bcb$export$86b5cdc1c559b81d; });
$parcel$export(module.exports, "tabbedHeroSectionDatabasesMessages", function () { return $5ec21e3943929bcb$export$505de7052a30846e; });
$parcel$export(module.exports, "tabbedHeroSectionSpacesMessages", function () { return $5ec21e3943929bcb$export$954db68b244e5987; });

var $fnHPc = parcelRequire("fnHPc");
const $5ec21e3943929bcb$export$4256e39427240bad = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.tabName",
        defaultMessage: "Pages"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.title.v2",
        defaultMessage: "Get everyone on the same page"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.description.v2",
        defaultMessage: "Take notes, plan projects, and refine ideas with flexible Confluence live docs and pages. Or let AI do it for you."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.iconsHeader",
        defaultMessage: "Create content with ease:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon1",
        defaultMessage: "Countless templates to get started fast"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon2",
        defaultMessage: "Realtime collaboration with live docs, or draft and publish with pages"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.icon3",
        defaultMessage: "AI editor to fill in the blanks"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Pages.cta",
        defaultMessage: "Try it out"
    }
});
const $5ec21e3943929bcb$export$86b5cdc1c559b81d = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.tabName",
        defaultMessage: "Whiteboards"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.title",
        defaultMessage: "Next-gen brainstorming"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.description",
        defaultMessage: "Capture free-flowing thoughts and collaborate on ideas with Confluence Whiteboards."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.iconsHeader",
        defaultMessage: "Ideate on an infinite canvas with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon1",
        defaultMessage: "Brainstorming templates"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon2",
        defaultMessage: "Diagrams and flow charts"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.icon3",
        defaultMessage: "Team retrospectives"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Whiteboards.cta",
        defaultMessage: "Explore Whiteboards"
    }
});
const $5ec21e3943929bcb$export$505de7052a30846e = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabName",
        defaultMessage: "Databases"
    },
    tabLozenge: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.tabLozenge",
        defaultMessage: "beta"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.title",
        defaultMessage: "A new way to stay in sync"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.description",
        defaultMessage: "Add structure, sync in real-time, and visualize your team\u2019s work with Confluence Databases."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.iconsHeader",
        defaultMessage: "Connect and relate information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon1",
        defaultMessage: "Dynamic fields"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon2",
        defaultMessage: "Configurable views"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.icon3",
        defaultMessage: "Aggregated data sources"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Databases.cta",
        defaultMessage: "Explore Databases"
    }
});
const $5ec21e3943929bcb$export$954db68b244e5987 = (0, $fnHPc.defineMessages)({
    tabName: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.tabName",
        defaultMessage: "Spaces"
    },
    contentTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.title",
        defaultMessage: "Find what you need"
    },
    contentDescription: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.description",
        defaultMessage: "Organize knowledge across teams, projects, and goals with Spaces in Confluence."
    },
    contentIconTitle: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.iconsHeader",
        defaultMessage: "Discover relevant information with:"
    },
    contentFeaturePoint1: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon1",
        defaultMessage: "Structured page tree"
    },
    contentFeaturePoint2: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon2",
        defaultMessage: "Centralized access to knowledge"
    },
    contentFeaturePoint3: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.icon3",
        defaultMessage: "Customizable permissions"
    },
    contentCta: {
        id: "ConfluenceSoftwarePage.v4.ContentTypes.Spaces.cta",
        defaultMessage: "Explore knowledge sharing"
    }
});

});

parcelRegister("l22jm", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return (parcelRequire("8IYGL")).Adg4TextUnderline; });
parcelRequire("8IYGL");

});
parcelRegister("8IYGL", function(module, exports) {
$parcel$export(module.exports, "Adg4TextUnderline", function () { return $37a3584e5be26d24$export$a8ef4069b9c5e8b7; });
/* text-underline.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");
const $37a3584e5be26d24$var$textStyle = null;
const $37a3584e5be26d24$var$inViewTextStyle = null;
const $37a3584e5be26d24$var$underlineStyle = null;
const $37a3584e5be26d24$var$inViewUnderlineStyle = null;
const $37a3584e5be26d24$var$hiddenText = null;
const $37a3584e5be26d24$var$visibleText = null;
const $37a3584e5be26d24$export$a8ef4069b9c5e8b7 = ({ text: text, children: children, underline: underline, underlineInset: underlineInset = "-37.5%", underlineLeft: underlineLeft = false, fontWeight: fontWeight = {
    from: 400,
    to: 800
}, useInViewOptions: useInViewOptions })=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)(useInViewOptions);
    const fontWeightAnimation = null;
    const underlineInsetStyle = null;
    const toFontWeight = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_1e0c116y _19pkidpf _2hwxidpf _otyridpf _18u0idpf _kqswh2mm _ju251bs3 _5sagfnf5 _tip8kb7n _1o51q7pw _vwz4kb7n _1nmz1hna",
            sectionIsVisible && "_j7hq1dkr"
        ]),
        style: {
            "--_15xzfe0": (0, $6ZVlx.default)(fontWeight.from),
            "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_3um015vq _lcxvglyw",
                    "_k48p103h"
                ]),
                style: {
                    "--_1bgzcf7": (0, $6ZVlx.default)(fontWeight.to)
                },
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_kqswstnw _1e02idpf"
                ]),
                children: text !== null && text !== void 0 ? text : children
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bsb1osq _mkrz16t8 _ju251bs3 _5sagpwmj _tip8kb7n _1e02idpf _1o51q7pw _kqswstnw _1pby1mrw",
                    "_u7co11y5 _cjf710zq _1kni10zq",
                    sectionIsVisible && "_j7hqzu28"
                ]),
                style: {
                    "--_1jmpxqi": (0, $6ZVlx.default)(underlineInset),
                    "--_p0j3r4": (0, $6ZVlx.default)(underlineLeft ? "0" : "auto")
                },
                children: underline
            })
        ]
    });
};

});


parcelRegister("4szpS", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f53fe53f7c5942$var$_react = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $33f53fe53f7c5942$var$_baseNew = $33f53fe53f7c5942$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $33f53fe53f7c5942$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f53fe53f7c5942$var$BacklogIcon = (props)=>/*#__PURE__*/ $33f53fe53f7c5942$var$_react.default.createElement($33f53fe53f7c5942$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$33f53fe53f7c5942$var$BacklogIcon.displayName = 'BacklogIcon';
var $33f53fe53f7c5942$var$_default = module.exports.default = $33f53fe53f7c5942$var$BacklogIcon;

});

parcelRegister("ppCkT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $04c634faffce0aa7$var$_react = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $04c634faffce0aa7$var$_baseNew = $04c634faffce0aa7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $04c634faffce0aa7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $04c634faffce0aa7$var$DepartmentIcon = (props)=>/*#__PURE__*/ $04c634faffce0aa7$var$_react.default.createElement($04c634faffce0aa7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$04c634faffce0aa7$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $04c634faffce0aa7$var$_default = module.exports.default = $04c634faffce0aa7$var$DepartmentIcon;

});

parcelRegister("b2tob", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8096adab141a7275$var$_react = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8096adab141a7275$var$_baseNew = $8096adab141a7275$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8096adab141a7275$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8096adab141a7275$var$EditIcon = (props)=>/*#__PURE__*/ $8096adab141a7275$var$_react.default.createElement($8096adab141a7275$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$8096adab141a7275$var$EditIcon.displayName = 'EditIcon';
var $8096adab141a7275$var$_default = module.exports.default = $8096adab141a7275$var$EditIcon;

});

parcelRegister("ggVkr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8a9c39c889598d$var$_react = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bd8a9c39c889598d$var$_baseNew = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bd8a9c39c889598d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd8a9c39c889598d$var$PersonAddIcon = (props)=>/*#__PURE__*/ $bd8a9c39c889598d$var$_react.default.createElement($bd8a9c39c889598d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$bd8a9c39c889598d$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $bd8a9c39c889598d$var$_default = module.exports.default = $bd8a9c39c889598d$var$PersonAddIcon;

});

parcelRegister("gjva1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $be06978ded12aba7$var$_react = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $be06978ded12aba7$var$_baseNew = $be06978ded12aba7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $be06978ded12aba7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $be06978ded12aba7$var$TeamsIcon = (props)=>/*#__PURE__*/ $be06978ded12aba7$var$_react.default.createElement($be06978ded12aba7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$be06978ded12aba7$var$TeamsIcon.displayName = 'TeamsIcon';
var $be06978ded12aba7$var$_default = module.exports.default = $be06978ded12aba7$var$TeamsIcon;

});

parcelRegister("9dCmO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6b6316d01b13082f$var$_react = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6b6316d01b13082f$var$_baseNew = $6b6316d01b13082f$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $6b6316d01b13082f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6b6316d01b13082f$var$CommentIcon = (props)=>/*#__PURE__*/ $6b6316d01b13082f$var$_react.default.createElement($6b6316d01b13082f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$6b6316d01b13082f$var$CommentIcon.displayName = 'CommentIcon';
var $6b6316d01b13082f$var$_default = module.exports.default = $6b6316d01b13082f$var$CommentIcon;

});

parcelRegister("6zF1U", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c95d69c59142f9b$var$_react = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c95d69c59142f9b$var$_baseNew = $4c95d69c59142f9b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $4c95d69c59142f9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c95d69c59142f9b$var$LightbulbIcon = (props)=>/*#__PURE__*/ $4c95d69c59142f9b$var$_react.default.createElement($4c95d69c59142f9b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$4c95d69c59142f9b$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $4c95d69c59142f9b$var$_default = module.exports.default = $4c95d69c59142f9b$var$LightbulbIcon;

});

parcelRegister("6hzTZ", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return (parcelRequire("c0p5s")).TabsWithCards; });
parcelRequire("c0p5s");

});
parcelRegister("c0p5s", function(module, exports) {
$parcel$export(module.exports, "TabsWithCards", function () { return $d6274292653c0a3a$export$3c855d4d211f5f7e; });
/* tabs-with-cards.pattern.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");
parcelRequire("1oC0p");

var $a9lfn = parcelRequire("a9lfn");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");
const $d6274292653c0a3a$var$Tab = ({ title: title, isSelected: isSelected, dataEventProps: dataEventProps })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", (0, $edEzO._)((0, $6Ppys._)({}, dataEventProps), {
        className: (0, $2jatx.default)([
            "_1ul9ymf6 _bfhk17fj _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _4t3i12am _2rko1f4h _y4ti1ul9 _bozg1ul9 _80omtlke _19it1hmt _ect4lnmy _k48p1nn1 _1wybgktf _1dbzzucj _1bg41b66 _nt751hlo",
            isSelected && "_19it8djs _bfhk1ybm"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
            "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
        },
        children: title
    }));
};
const $d6274292653c0a3a$export$3c855d4d211f5f7e = ({ h2Text: h2Text, tabsData: tabsData })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4Tabs), {
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            "_1bsb1osq _y3gn1h6o _6rthidpf"
                        ]),
                        children: h2Text
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTabList), {
                    rowGap: "12px",
                    className: (0, $2jatx.default)([
                        "_ca0q1ylp _u5f31wqb _n3td1qjk _19bv1wqb _1kmx1ylp _1ggmzwfg _1ykz1ul9 _1maezwfg",
                        "tab-list"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                            tabIndex: index,
                            className: "round-tab",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($d6274292653c0a3a$var$Tab, {
                                title: tab.title,
                                dataEventProps: {
                                    "data-product-key": "home",
                                    "data-event": "clicked",
                                    "data-event-component": "button",
                                    "data-event-container": "tabsMenu",
                                    "data-label": tab.title,
                                    "data-label-english": tab.englishLabel
                                }
                            })
                        }, index))
                }),
                tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                        panelIndex: index,
                        id: tab.id,
                        children: tab.tabComponent
                    }, index))
            ]
        })
    });
};
const $d6274292653c0a3a$var$sectionStyles = null;
const $d6274292653c0a3a$var$h2Styles = null;
const $d6274292653c0a3a$var$tabList = null;
const $d6274292653c0a3a$var$tabStyles = null;
const $d6274292653c0a3a$var$currentStyle = null;

});


parcelRegister("682Ua", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $89f20ef110b77061$export$2e2bcd8739ae039; });
/* tabs-content.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $6Ppys = parcelRequire("6Ppys");

var $edEzO = parcelRequire("edEzO");

var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $jMhSx = parcelRequire("jMhSx");

var $5yuBp = parcelRequire("5yuBp");
const $89f20ef110b77061$var$settings = {
    arrows: false,
    centerMode: true,
    dots: true,
    infinite: false,
    swipeToSlide: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
// FIXME: Nested selectors are used here to target dynamically inserted child elements
const $89f20ef110b77061$var$slickStyle = null;
const $89f20ef110b77061$var$TabsContent = (tabsContentProps)=>{
    var _tabsContentProps_contentLink, _tabsContentProps_contentLink1, _tabsContentProps_contentLink2;
    const isMobile = (0, $5yuBp.useIsMobile)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.TypographyStyles), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_y44v951u",
                tabsContentProps.className || ""
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_dm2511p5 _1rqtaigu _pdlmzwfg"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_uhi5kb7n _eao7qfx8"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kzvi1txw _1gzvzwfg",
                                            "content-list"
                                        ]),
                                        children: tabsContentProps.contentList.map((content, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_xlt17vkz _40tuftgi _1tnt1tcg _v9tzum4z _p6svglyw",
                                                    "content-text"
                                                ]),
                                                style: {
                                                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400"))
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                                                        className: (0, $2jatx.default)([
                                                            "_6rthidpf _1pfhidpf",
                                                            content === null || content === void 0 ? void 0 : content.headerType
                                                        ]),
                                                        children: content.headerText
                                                    }),
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                        className: (0, $2jatx.default)([
                                                            "_476dftgi"
                                                        ]),
                                                        children: content.bodyText
                                                    })
                                                ]
                                            }, "content-" + index))
                                    }),
                                    tabsContentProps.contentLink && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_gq9a1h6o",
                                            "link-content-container"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                            href: tabsContentProps.contentLink.link,
                                            text: (_tabsContentProps_contentLink = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink === void 0 ? void 0 : _tabsContentProps_contentLink.linkText,
                                            type: "primary",
                                            dataEventProps: {
                                                "data-product-key": (_tabsContentProps_contentLink1 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink1 === void 0 ? void 0 : _tabsContentProps_contentLink1.productKey,
                                                "data-event": "clicked",
                                                "data-event-component": "linkButton",
                                                "data-event-container": "tabsSection",
                                                "data-label-english": (_tabsContentProps_contentLink2 = tabsContentProps.contentLink) === null || _tabsContentProps_contentLink2 === void 0 ? void 0 : _tabsContentProps_contentLink2.linkLabel
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1reo15vq _18m915vq _uhi5qfx8 _eao71mrw _1iyegktf"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), (0, $edEzO._)((0, $6Ppys._)({}, tabsContentProps.pictureProps), {
                                    className: (0, $2jatx.default)([
                                        "_rtys1osq _1jpx1f51 _mezj1osq _1oo31q9y _bna71wug _m369951u _ovn1i2wt"
                                    ])
                                }))
                            })
                        ]
                    })
                }),
                tabsContentProps.tabContentEyebrowText && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: "tab-content-header-wrapper",
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                            className: (0, $2jatx.default)([
                                "_y3gn1h6o _1pfhidpf _6rth1tcg",
                                "eyebrow-md"
                            ]),
                            children: tabsContentProps.tabContentEyebrowText
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: "tabs-content-cards",
                    children: isMobile ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _11wpftgi _ehjsftgi _13e4ftgi _12l3ftgi _gzcot94y _1xnx1ule _6rj8idpf _k58e13la _qmn3idpf _bjmnidpf _6qh814y2 _1qzl14y2 _1dx414y2 _1n6c14y2 _1mfj1h6o _12bq1o8l _nog6tlke _1njogktf _1ssvgktf _110yidpf _1glb14y2 _1a57idpf _c30z14y2 _1yjcidpf _qop8idpf _63deidpf _l4aeidpf _1jkiidpf _1xco1ule _je42idpf _176uidpf _rtji14y2 _1jth14y2 _9af414y2 _9uha14y2 _11votlke _omsfgktf _6fzegktf _5l3c1j28 _iygb1j28 _c2ls1r31 _6ejeglyw _1e79idpf _54up1hlo _1gdw1osq _cshx1hlo _2g951ssb _1f1o1mp2 _z3otldb6 _w1ixgktf _1kauidpf _fcd11h6o _slqlidpf _4if1gktf _vcsd13la _1wxl1h6o"
                        ]),
                        style: {
                            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                        },
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), (0, $edEzO._)((0, $6Ppys._)({}, $89f20ef110b77061$var$settings), {
                            children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($89f20ef110b77061$var$TabCard, (0, $6Ppys._)({}, cardContent))
                                }, "card-" + index))
                        }))
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jMhSx.Row), {
                        layout: "4-4-4",
                        containerType: "ul",
                        children: tabsContentProps.cardsContent.map((cardContent, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).Fragment, {
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)($89f20ef110b77061$var$TabCard, (0, $edEzO._)((0, $6Ppys._)({}, cardContent), {
                                    containerType: "li"
                                }))
                            }, "card-" + index))
                    })
                })
            ]
        })
    });
};
const $89f20ef110b77061$var$slidein = null;
const $89f20ef110b77061$var$wrapperStyles = null;
const $89f20ef110b77061$var$bigImgWrapperStyles = null;
const $89f20ef110b77061$var$contentListWrapperStyle = null;
const $89f20ef110b77061$var$contentListTextWrapperStyle = null;
const $89f20ef110b77061$var$contentListStyles = null;
const $89f20ef110b77061$var$contentImageStyle = null;
const $89f20ef110b77061$var$eyebrowStyle = null;
const $89f20ef110b77061$var$ContentTextStyles = null;
const $89f20ef110b77061$var$ContentTextPStyle = null;
const $89f20ef110b77061$var$contentListHeaderStyle = null;
const $89f20ef110b77061$var$linkContainerStyle = null;
const $89f20ef110b77061$var$TabCard = (cardContentProps)=>{
    const { eyebrowText: eyebrowText, headerText: headerText, bodyText: bodyText, ctaProps: ctaProps, pictureProps: pictureProps, containerType: containerType } = cardContentProps;
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Card), {
        title: headerText,
        titleAs: "h3",
        image: pictureProps,
        body: bodyText,
        eyebrow: eyebrowText,
        callToAction: ctaProps,
        containerType: containerType
    });
};
var $89f20ef110b77061$export$2e2bcd8739ae039 = $89f20ef110b77061$var$TabsContent;

});

parcelRegister("8BlKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6432a540254daa54$var$_react = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6432a540254daa54$var$_baseNew = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6432a540254daa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6432a540254daa54$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $6432a540254daa54$var$_react.default.createElement($6432a540254daa54$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$6432a540254daa54$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $6432a540254daa54$var$_default = module.exports.default = $6432a540254daa54$var$RoadmapsPlanIcon;

});

parcelRegister("ehGJT", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fa0a7a20e9878c1f12b50feba4970dc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a663ce5ab5e4ae47$var$_react = $a663ce5ab5e4ae47$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a663ce5ab5e4ae47$var$_baseNew = $a663ce5ab5e4ae47$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a663ce5ab5e4ae47$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WorkItems".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing multiple work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a663ce5ab5e4ae47$var$WorkItemsIcon = (props)=>/*#__PURE__*/ $a663ce5ab5e4ae47$var$_react.default.createElement($a663ce5ab5e4ae47$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5zM9.448 5.608l-3.167 3.75a.75.75 0 0 1-1.09.061l-.055-.06-1.584-1.876 1.146-.966 1.01 1.196 2.594-3.071zM13 10a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2z"/><path fill="currentcolor" d="M14.5 11.75V7H16v4.75A3.25 3.25 0 0 1 12.75 15H5v-1.5h7.75a1.75 1.75 0 0 0 1.75-1.75"/>`
    }, props));
$a663ce5ab5e4ae47$var$WorkItemsIcon.displayName = 'WorkItemsIcon';
var $a663ce5ab5e4ae47$var$_default = module.exports.default = $a663ce5ab5e4ae47$var$WorkItemsIcon;

});

parcelRegister("lfTOg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f7964a51710834b2$var$_react = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f7964a51710834b2$var$_baseNew = $f7964a51710834b2$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $f7964a51710834b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f7964a51710834b2$var$CalendarIcon = (props)=>/*#__PURE__*/ $f7964a51710834b2$var$_react.default.createElement($f7964a51710834b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$f7964a51710834b2$var$CalendarIcon.displayName = 'CalendarIcon';
var $f7964a51710834b2$var$_default = module.exports.default = $f7964a51710834b2$var$CalendarIcon;

});

parcelRegister("kAq28", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $efcb5d22d8bd146c$var$_react = $efcb5d22d8bd146c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $efcb5d22d8bd146c$var$_baseNew = $efcb5d22d8bd146c$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $efcb5d22d8bd146c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $efcb5d22d8bd146c$var$IncidentIcon = (props)=>/*#__PURE__*/ $efcb5d22d8bd146c$var$_react.default.createElement($efcb5d22d8bd146c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$efcb5d22d8bd146c$var$IncidentIcon.displayName = 'IncidentIcon';
var $efcb5d22d8bd146c$var$_default = module.exports.default = $efcb5d22d8bd146c$var$IncidentIcon;

});


var $3NQOU = parcelRequire("3NQOU");

var $jNwD4 = parcelRequire("jNwD4");
(0, $3NQOU.init)((0, $jNwD4.HomePage));


//# sourceMappingURL=home.183729dd.js.map
